document.addEventListener('DOMContentLoaded', () => {
  console.log('Tile Calculator script loaded');

  class TileCalculator {
    constructor() {
      // Debug elements are now optional
      this.debugElement = document.getElementById('calculator-debug');
      this.currentSqftElement = document.getElementById('current-sqft');

      this.elements = {
        lengthInput: document.querySelector('#tile-length'),
        widthInput: document.querySelector('#tile-width'),
        areaInput: document.querySelector('#tile-area'),
        quantityInput: document.querySelector('#tile-quantity'),
        extraCheckbox: document.querySelector("#add-cover-break")
      };

      // Initialize with the current variant's square footage
      const currentVariantId = this.getSelectedVariantId();
      
      if (window.tileCalculatorData && window.tileCalculatorData.variantData) {
        this.squareFootagePerBox = parseFloat(window.tileCalculatorData.variantData[currentVariantId]);
      } else {
        console.error('Tile Calculator: No variant data found!');
        return;
      }

      if (isNaN(this.squareFootagePerBox) || this.squareFootagePerBox <= 0) {
        console.error("Tile Calculator: Invalid square footage per box value!");
        return;
      }

      this.bindEvents();
      this.setupInputValidation();
    }

    // Only update debug if elements exist
    updateDebugDisplay() {
      if (this.debugElement && this.currentSqftElement) {
        this.currentSqftElement.textContent = this.squareFootagePerBox.toFixed(2);
      }
    }

    // Rest of your code stays exactly the same
    getSelectedVariantId() {
      const variantIdElement = document.querySelector('input[name="id"]');
      if (variantIdElement) return variantIdElement.value;
      const urlParams = new URLSearchParams(window.location.search);
      const variantFromUrl = urlParams.get('variant');
      if (variantFromUrl) return variantFromUrl;
      return Object.keys(window.tileCalculatorData.variantData)[0];
    }

    setupInputValidation() {
      const numberInputs = [
        this.elements.lengthInput,
        this.elements.widthInput,
        this.elements.areaInput,
        this.elements.quantityInput
      ];

      numberInputs.forEach(input => {
        if (input) {
          input.setAttribute('min', '0');
          input.addEventListener('keypress', (e) => {
            if (e.key === '-' || e.key === '+') {
              e.preventDefault();
            }
          });
          input.addEventListener('blur', () => {
            const value = parseFloat(input.value);
            if (value < 0) {
              input.value = '0';
            }
          });
        }
      });
    }

    bindEvents() {
      this.elements.lengthInput?.addEventListener('input', () => this.calculateArea());
      this.elements.widthInput?.addEventListener('input', () => this.calculateArea());
      this.elements.areaInput?.addEventListener('input', () => {
        this.clearLengthWidth();
        this.calculateBoxes();
      });
      this.elements.quantityInput?.addEventListener('input', () => {
        this.clearLengthWidth();
        this.calculateArea();
      });
      if (this.elements.extraCheckbox) {
        this.elements.extraCheckbox.addEventListener('change', () => this.calculateBoxes());
      }

      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', () => this.onVariantChange());
      }

      const swatches = document.querySelectorAll('.swatch-view-item');
      swatches.forEach(swatch => {
        swatch.addEventListener('click', () => this.onVariantChange());
        swatch.addEventListener('change', () => this.onVariantChange());
      });

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'aria-checked' || 
               mutation.attributeName === 'class')) {
            this.onVariantChange();
            break;
          }
        }
      });

      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-checked', 'class']
      });
    }

    onVariantChange() {
      const currentVariantId = this.getSelectedVariantId();
      
      if (window.tileCalculatorData && window.tileCalculatorData.variantData) {
        const newSquareFootage = parseFloat(window.tileCalculatorData.variantData[currentVariantId]);
        
        if (!isNaN(newSquareFootage) && newSquareFootage > 0) {
          this.squareFootagePerBox = newSquareFootage;
          this.updateDebugDisplay();
          this.calculateBoxes();
        }
      }
    }

    clearLengthWidth() {
      if (this.elements.lengthInput) this.elements.lengthInput.value = '';
      if (this.elements.widthInput) this.elements.widthInput.value = '';
    }

    calculateArea() {
      if (document.activeElement === this.elements.quantityInput) {
        let boxes = parseFloat(this.elements.quantityInput.value) || 0;
        let area = (boxes * this.squareFootagePerBox).toFixed(2);
        this.elements.areaInput.value = area;
        return;
      }
      
      let length = parseFloat(this.elements.lengthInput.value) || 0;
      let width = parseFloat(this.elements.widthInput.value) || 0;
      let area = (length * width).toFixed(2);
      this.elements.areaInput.value = area;
      this.calculateBoxes();
    }

    calculateBoxes() {
  let area = parseFloat(this.elements.areaInput.value) || 0;
  let addExtra = this.elements.extraCheckbox?.checked || false;
  
  if (area > 0) {
    let boxesNeeded = Math.ceil(area / this.squareFootagePerBox);
    if (addExtra) {
      boxesNeeded = Math.ceil(boxesNeeded * 1.1);
    }
    this.elements.quantityInput.value = boxesNeeded;
    // Update the value and trigger the change event
    const shopifyQty = document.querySelector('input[name="quantity"]');
    shopifyQty.value = boxesNeeded;
    shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
  } else {
    this.elements.quantityInput.value = 1;
    const shopifyQty = document.querySelector('input[name="quantity"]');
    shopifyQty.value = 1;
    shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
  }

  // Initialize the Tile Calculator
  const calculator = new TileCalculator();
});